import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useAuth } from "../context/AuthContext";

const StatusBar = () => {
  const { user } = useAuth();
  const [currentTime, setCurrentTime] = useState("");

  useEffect(() => {
    const updateTime = () => {
      const formatter = new Intl.DateTimeFormat("de-AT", {
        timeZone: "Europe/Vienna",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      });
      setCurrentTime(formatter.format(new Date()));
    };

    updateTime();
    const timer = setInterval(updateTime, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        height: "32px",
        backgroundColor: "#04182d",
        borderTop: "1px solid rgba(112, 197, 255, 0.2)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 2,
        zIndex: (theme) => theme.zIndex.drawer + 1,
        boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.3)",
      }}
    >
      <Typography
        variant="caption"
        sx={{
          color: "#ffffff",
          fontSize: "0.75rem",
          fontWeight: 500,
        }}
      >
        {currentTime}
      </Typography>
      <Typography
        variant="caption"
        sx={{
          color: "#ffffff",
          fontSize: "0.75rem",
          fontWeight: 500,
        }}
      >
        {user ? user.username : "Nicht eingeloggt"}
      </Typography>
    </Box>
  );
};

export default StatusBar;

